import { render, staticRenderFns } from "./admitGenerate.vue?vue&type=template&id=732a836c&scoped=true&"
import script from "./admitGenerate.vue?vue&type=script&lang=js&"
export * from "./admitGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a836c",
  null
  
)

export default component.exports